/* ============================================================
   PILOTE AUTREMENT — interactions
   No dependencies. Progressive enhancement only: every feature
   degrades to plain, usable HTML if this file fails to load.
   ============================================================ */
(function () {
  'use strict';

  // Tells the inline bootstrap that this file arrived, so the reveal
  // styles are never left hiding content when the script fails to load.
  window.__paBooted = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Header depth on scroll ---------- */
  function initHeader() {
    var header = document.querySelector('[data-pa-header]');
    if (!header) return;

    // Toggled directly, not through requestAnimationFrame: a rAF callback is
    // paused while the tab is hidden, which used to leave the throttle flag
    // stuck and the header frozen until reload. A class toggle is cheap enough
    // to run on every scroll event, and it only controls the shadow — the bar
    // is legible either way.
    function update() { header.classList.toggle('is-solid', window.scrollY > 24); }
    window.addEventListener('scroll', update, { passive: true });
    document.addEventListener('visibilitychange', update);
    update();
  }

  /* ---------- Desktop dropdown menus ---------- */
  function initDropdowns() {
    var items = document.querySelectorAll('[data-pa-drop]');
    if (!items.length) return;

    function closeAll(except) {
      items.forEach(function (item) {
        if (item === except) return;
        item.classList.remove('is-open');
        var btn = item.querySelector('.pa-nav__link');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
    }

    items.forEach(function (item) {
      var btn = item.querySelector('.pa-nav__link');
      if (!btn) return;
      var closeTimer;

      function open() {
        window.clearTimeout(closeTimer);
        closeAll(item);
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
      function close() {
        item.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
      }
      function scheduleClose() {
        closeTimer = window.setTimeout(close, 140);
      }

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        item.classList.contains('is-open') ? close() : open();
      });
      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', scheduleClose);
      item.addEventListener('focusin', open);
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) close();
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll(null);
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-pa-drop]')) closeAll(null);
    });
  }

  /* ---------- Mobile drawer ---------- */
  function initDrawer() {
    var drawer = document.querySelector('[data-pa-drawer]');
    var toggle = document.querySelector('[data-pa-burger]');
    if (!drawer || !toggle) return;

    var panel = drawer.querySelector('.pa-drawer__panel');
    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      drawer.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('pa-noscroll');
      document.body.classList.add('pa-noscroll');
      var first = panel.querySelector('a, button');
      if (first) window.setTimeout(function () { first.focus(); }, 60);
    }
    function close() {
      drawer.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('pa-noscroll');
      document.body.classList.remove('pa-noscroll');
      if (lastFocus) lastFocus.focus();
    }

    toggle.addEventListener('click', function () {
      drawer.classList.contains('is-open') ? close() : open();
    });
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-pa-drawer-close]') || e.target.classList.contains('pa-drawer__scrim')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
      // Focus trap
      if (e.key === 'Tab' && drawer.classList.contains('is-open')) {
        var f = panel.querySelectorAll('a[href], button:not([disabled])');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  }

  /* ---------- FAQ accordion ---------- */
  function initFaq() {
    var buttons = document.querySelectorAll('[data-pa-faq]');
    buttons.forEach(function (btn) {
      var panelId = btn.getAttribute('aria-controls');
      var panel = panelId && document.getElementById(panelId);
      if (!panel) return;
      var inner = panel.firstElementChild;

      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open));
        if (reduceMotion) { panel.style.height = open ? '0px' : 'auto'; return; }
        if (open) {
          panel.style.height = inner.offsetHeight + 'px';
          window.requestAnimationFrame(function () { panel.style.height = '0px'; });
        } else {
          panel.style.height = inner.offsetHeight + 'px';
          // transitionend can be dropped (hidden tab, interrupted transition),
          // which would leave the panel pinned at a fixed height.
          var settled = false;
          var settle = function () {
            if (settled) return;
            settled = true;
            panel.style.height = 'auto';
            panel.removeEventListener('transitionend', settle);
          };
          panel.addEventListener('transitionend', settle);
          window.setTimeout(settle, 400);
        }
      });
    });
  }

  /* ---------- Reveal on scroll ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.pa-reveal');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var delay = parseInt(el.getAttribute('data-pa-delay') || '0', 10);
        window.setTimeout(function () { el.classList.add('is-in'); }, delay);
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Sticky mobile CTA ---------- */
  function initSticky() {
    var bar = document.querySelector('[data-pa-sticky]');
    var trigger = document.querySelector('[data-pa-sticky-after]');
    if (!bar || !trigger) return;
    var stop = document.querySelector('[data-pa-sticky-stop]');

    // Position-based rather than IntersectionObserver: observers only fire on
    // threshold crossings, so a jump scroll past both elements left the bar stuck.
    function update() {
      var past = window.scrollY > (trigger.offsetTop + trigger.offsetHeight - 40);
      var atStop = false;
      if (stop) atStop = stop.getBoundingClientRect().top < window.innerHeight;
      bar.classList.toggle('is-in', past && !atStop);
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    document.addEventListener('visibilitychange', update);
    update();
  }

  /* ---------- Product gallery ---------- */
  function initGallery() {
    var gal = document.querySelector('[data-pa-gallery]');
    if (!gal) return;
    var stage = gal.querySelector('[data-pa-gallery-stage]');
    var count = gal.querySelector('[data-pa-gallery-count]');
    var thumbs = gal.querySelectorAll('[data-pa-gallery-thumb]');
    if (!stage || !thumbs.length) return;

    var current = 0;

    function select(btn, i) {
      var full = btn.getAttribute('data-full');
      var alt = btn.getAttribute('data-alt') || '';
      if (full) { stage.src = full; stage.alt = alt; }
      thumbs.forEach(function (t) { t.setAttribute('aria-current', String(t === btn)); });
      if (count) count.textContent = (i + 1) + ' / ' + thumbs.length;
      current = i;
    }
    thumbs.forEach(function (btn, i) {
      btn.addEventListener('click', function () { select(btn, i); });
    });
    if (count) count.textContent = '1 / ' + thumbs.length;

    // Arrows wrap around, so neither one is ever a dead control.
    function step(delta) {
      var next = (current + delta + thumbs.length) % thumbs.length;
      select(thumbs[next], next);
      // Keep the active thumbnail inside its scroller.
      if (thumbs[next].scrollIntoView) {
        thumbs[next].scrollIntoView({ block: 'nearest', inline: 'nearest',
          behavior: reduceMotion ? 'auto' : 'smooth' });
      }
    }
    var prev = gal.querySelector('[data-pa-gallery-prev]');
    var next = gal.querySelector('[data-pa-gallery-next]');
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    gal.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
    });
  }

  /* ---------- Promo countdown ---------- */
  function initPromo() {
    var bar = document.querySelector('[data-pa-promo]');
    if (!bar) return;

    var end = Date.parse(bar.getAttribute('data-deadline'));
    if (isNaN(end)) return;                     // no valid date: stay hidden

    var clock = bar.querySelector('[data-pa-clock]');
    var d = clock.querySelector('[data-d]'), h = clock.querySelector('[data-h]');
    var m = clock.querySelector('[data-m]'), sEl = clock.querySelector('[data-s]');
    var pad = function (n) { return n < 10 ? '0' + n : String(n); };
    var timer;

    function retire() {
      window.clearInterval(timer);
      bar.hidden = true;
      // Give the height back so the nav returns to the top of the page.
      document.documentElement.style.setProperty('--pa-top-extra', '0px');
    }

    function tick() {
      var left = end - Date.now();
      if (left <= 0) { retire(); return; }      // never restarts
      var secs = Math.floor(left / 1000);
      d.textContent = pad(Math.floor(secs / 86400));
      h.textContent = pad(Math.floor(secs / 3600) % 24);
      m.textContent = pad(Math.floor(secs / 60) % 60);
      sEl.textContent = pad(secs % 60);
    }

    if (end - Date.now() <= 0) { retire(); return; }
    bar.hidden = false;
    tick();
    timer = window.setInterval(tick, 1000);
  }

  /* ---------- Hourly offer strip ---------- */
  // The window is the running clock hour: it ends on the hour and the next one
  // opens immediately. Nothing here changes a price — the strip only states how
  // much of the current hour is left, so the shop stays the single source of
  // truth for what is actually being charged.
  function initHourlyOffer() {
    var strips = document.querySelectorAll('[data-pa-hourly]');
    if (!strips.length) return;

    var clocks = [];
    strips.forEach(function (strip) {
      var clock = strip.querySelector('[data-pa-hourly-clock]');
      if (!clock) return;
      clocks.push({
        strip: strip,
        h: clock.querySelector('[data-h]'),
        m: clock.querySelector('[data-m]'),
        s: clock.querySelector('[data-s]'),
      });
      strip.hidden = false;
    });
    if (!clocks.length) return;

    function pad(n) { return n < 10 ? '0' + n : String(n); }

    // Each clock reads its own window. Windows are aligned to the wall clock,
    // so every visitor sees the same countdown rather than a private one that
    // restarts on reload.
    function endOfWindow(hours) {
      var d = new Date();
      var next = (Math.floor(d.getHours() / hours) + 1) * hours;
      d.setHours(next, 0, 0, 0);       // rolls into the next day on its own
      return d.getTime();
    }

    clocks.forEach(function (c) {
      c.hours = parseInt(c.strip.getAttribute('data-window') || '1', 10) || 1;
      c.end = endOfWindow(c.hours);
    });

    // Recomputed from Date.now() on every tick rather than counted down, so a
    // throttled background tab or a slept laptop resumes on the real time left.
    function tick() {
      clocks.forEach(function (c) {
        var left = c.end - Date.now();
        if (left <= 0) {
          c.end = endOfWindow(c.hours);
          left = c.end - Date.now();
        }
        var total = Math.floor(left / 1000);
        var h = Math.floor(total / 3600);
        var m = Math.floor((total % 3600) / 60);
        var sec = total % 60;
        if (c.h) c.h.textContent = pad(h);
        if (c.m) c.m.textContent = pad(m);
        if (c.s) c.s.textContent = pad(sec);
      });
    }

    tick();
    setInterval(tick, 1000);

  }

  /* ---------- Reviews: clip the list, expand on demand ---------- */
  function initReviews() {
    document.querySelectorAll('[data-pa-reviews]').forEach(function (list) {
      var scope = list.closest('.pa-wrap') || document;
      var btn = scope.querySelector('[data-pa-reviews-more]');
      var cards = list.querySelectorAll('.pa-rv');
      var visible = parseInt(list.getAttribute('data-visible') || '6', 10);
      // Clipping is applied here, not in the markup: without this script every
      // review stays on the page instead of hiding behind a dead button.
      if (!btn || !cards.length || cards.length <= visible) return;

      function clip(on) {
        cards.forEach(function (card, i) {
          if (i < visible) return;
          if (on) card.setAttribute('data-pa-hidden', '');
          else card.removeAttribute('data-pa-hidden');
        });
        list.classList.toggle('is-clipped', on);
        btn.textContent = btn.getAttribute(on ? 'data-label-more' : 'data-label-less');
        btn.setAttribute('aria-expanded', String(!on));
      }

      btn.hidden = false;
      clip(true);

      btn.addEventListener('click', function () {
        var collapsing = !list.classList.contains('is-clipped');
        clip(collapsing);
        if (collapsing) {
          // Collapsing from the bottom of a long list would strand the reader
          // below the section; put them back on the first review.
          list.scrollIntoView({ block: 'start', behavior: reduceMotion ? 'auto' : 'smooth' });
        } else {
          var first = cards[visible];
          if (first) first.focus && first.focus();
        }
      });
    });
  }

  /* ---------- Product buy bar ---------- */
  // Distinct from the homepage sticky CTA: this one carries a real add-to-cart
  // form for the product being read, and it shows on every viewport because the
  // sales page is long on desktop too.
  function initBuybar() {
    var bar = document.querySelector('[data-pa-buybar]');
    if (!bar) return;
    var main = document.querySelector('#pa-buy-form [name="add"]');
    if (!main) return;
    var stop = document.querySelector('[data-pa-sticky-stop]');

    // Measured from the live rect on every scroll rather than through an
    // IntersectionObserver: a jump scroll past both elements used to leave the
    // bar stuck open, and this cannot.
    function update() {
      var passed = main.getBoundingClientRect().bottom < 0;
      var atEnd = stop ? stop.getBoundingClientRect().top < window.innerHeight : false;
      var show = passed && !atEnd;
      if (show === !bar.hidden) return;
      bar.hidden = !show;
      // The transition needs the element painted first, hence the frame delay.
      if (show) window.requestAnimationFrame(function () { bar.classList.add('is-in'); });
      else bar.classList.remove('is-in');
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    document.addEventListener('visibilitychange', update);
    update();
  }

  /* ---------- Live cart count ---------- */
  function initCart() {
    var badges = document.querySelectorAll('[data-pa-cartcount]');
    if (!badges.length) return;
    function paint(n) {
      badges.forEach(function (b) {
        b.textContent = n > 99 ? '99+' : String(n);
        b.setAttribute('data-count', String(n));
      });
    }
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (c) paint(c.item_count); })
      .catch(function () { /* keep server-rendered value */ });
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    document.documentElement.classList.add('pa-js');
    initHeader();
    initDropdowns();
    initDrawer();
    initFaq();
    initReveal();
    initSticky();
    initPromo();
    initHourlyOffer();
    initGallery();
    initBuybar();
    initReviews();
    initCart();
  });
})();
